import { createSlice } from '@reduxjs/toolkit';

const mapCoordinates = createSlice({
  name: 'mapCoordinates',
  initialState: { // Center of Maribor
    latitude: 46.548835,
    longitude: 15.650703,
    zoom: 11,
  },
  reducers: {
    setMapPosition: (state, action) => {
      const { latitude, longitude, zoom } = action.payload;
      state.latitude = latitude;
      state.longitude = longitude;
      state.zoom = zoom;
    }
  }
});

export const { setMapPosition } = mapCoordinates.actions;

export default mapCoordinates.reducer;
